<span class="cursor-poiner" (click)="navigateToGoogleMaps()">
  {{ 'GO_TO_GOOGLE_MAPS' | translate }}
  <span class="px-1"><img src="icons/google-maps.png" width="24" height="24" /></span
></span>
